exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-not-found {\n  text-align: center;\n  width: 100%;\n  height: 100%;\n  margin-top: -90px; }\n  .page-not-found .page-not-found-description {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 100%;\n    transform: translate(-50%, -50%);\n    padding: 10px; }\n    .page-not-found .page-not-found-description .img-responsive {\n      margin: auto; }\n    .page-not-found .page-not-found-description .text-not-found-strong {\n      margin-top: 30px;\n      font-size: 24px; }\n    .page-not-found .page-not-found-description .text-not-found {\n      color: #6b778c;\n      margin-top: 10px;\n      font-size: 18px; }\n\n@media screen and (max-width: 767px) {\n  .text-not-found-strong {\n    font-size: 20px !important; }\n  .text-not-found {\n    font-size: 14px !important; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/page-not-found-module/page-not-found/page-not-found.component.scss
// module id = 963
// module chunks = 22